import { useRef } from "react";
import WsrTqp from "./WsrStatics/WsrTqp";
import Support from "./WsrStatics/Support";
import Status from "./WsrStatics/Status";
import IndustryInsights from "./WsrStatics/IndustryInsights";
import KeyFactors from "./WsrStatics/Keyfactors";
import KeyCompetitors from "./WsrStatics/keyCompetitors";
import PptxGenJS from "pptxgenjs";
import WsrButton from "../../Components/Buttons/WsrButton";

const Wsr = () => {
  const captureRef = useRef(null);

  const handleCaptureAndAddToPpt = () => {
    const element = captureRef.current;
    const pptx = new PptxGenJS();
    const slide = pptx.addSlide();

    slide.addShape(pptx.ShapeType.rect, {
      x: 0,
      y: 0,
      w: 10,
      h: 5.63,
      line: { color: "000000", width: 1 },
      fill: { color: "FFFFFF", transparency: 100 },
    });

    slide.addShape(pptx.ShapeType.rect, {
      x: 0,
      y: 0, // Align at the top
      w: 10, // Full slide width
      h: 0.5, // Banner height
      fill: { color: "#2a5775" }, // Dark blue background
    });

    slide.addText("Weekly Sales Review", {
      x: 0,
      y: 0,
      w: 10,
      h: 0.5,
      fontSize: 20,
      bold: true,
      color: "#FFFFFF",
      align: "center",
      valign: "middle",
    });

    const headings = element.querySelectorAll(".heading");
    const tables = element.querySelectorAll("table");
    const tableWidth = 8.9 / 3;
    const maxHeight = 5 * 0.0625;
    const xOffsets = [0.3, 3.5, 6.7];
    const yOffsets = [1, 3];

    tables.forEach((table, index) => {
      const rowData = [];
      const firstColumnWidth = 0.7;

      const headingDiv = headings[index];
      const heading = headingDiv?.textContent?.trim() || `Table ${index + 1}`;

      table.querySelectorAll("tr").forEach((tr, rowIndex) => {
        const cellData = [];
        const cells = Array.from(tr.querySelectorAll("th, td"));

        // Skip the last column
        cells.slice(0, -1).forEach((cell, cellIndex) => {
          const fontSize = parseInt(window.getComputedStyle(cell).fontSize, 10);

          const isFirstColumnTd = cell.tagName === "TD" && cellIndex === 0;
          let backgroundColor =
            cell.tagName === "TH"
              ? "#2a5775" // Header cells color
              : isFirstColumnTd
              ? "#d4e1ec" // Light blue for first-column `td` cells
              : rowIndex % 2 === 0 // Alternate row coloring for other `td` cells
              ? "#e5e7eb" // Light gray for even rows
              : "#ffffff"; // White for odd rows

          cellData.push({
            text: cell.textContent.trim(),
            options: {
              fontSize: fontSize ? fontSize * 0.7 : 10,
              bold: cell.tagName === "TH",
              fill: {
                color: backgroundColor,
              },
              color: cell.tagName === "TH" ? "#FFFFFF" : "#000000",
              align: "center",
              valign: "middle",
              margin: 1,
            },
          });
        });
        rowData.push(cellData);
      });

      const xIndex = index % 3;
      const yIndex = Math.floor(index / 3);
      const xPos = xOffsets[xIndex];
      const yPos = yOffsets[yIndex];

      slide.addText(heading, {
        x: xPos - 0.1,
        y: yPos - 0.15, // Position heading slightly above the table
        fontSize: 10,
        bold: true,
        color: "#4c4c4c",
        align: "left",
        w: tableWidth,
      });

      slide.addTable(rowData, {
        x: xPos,
        y: yPos,
        w: tableWidth,
        h: Math.min(maxHeight, "auto"),
        colW: [
          firstColumnWidth,
          ...Array(rowData[0]?.length - 1).fill(
            (tableWidth - firstColumnWidth) / (rowData[0]?.length - 1 || 1)
          ),
        ],
        border: { pt: 1, color: "000000" },
        fill: { color: "#FFE5B4" },
      });
    });

    pptx.writeFile({ fileName: "Weekly Sales Review.pptx" });
  };

  return (
    <div ref={captureRef} style={{ backgroundColor: "#f2f5f9" }}>
      <section className="md:grid grid-cols-3 gap-3 mx-2 mt-1 sm:block">
        <IndustryInsights />
        <KeyFactors />
        <KeyCompetitors />
      </section>
      <section className="md:grid grid-cols-3 gap-3 mx-2 mt-1 sm:block">
        <Status />
        <WsrTqp />
        <Support />
      </section>
      <WsrButton handleCaptureAndAddToPpt={handleCaptureAndAddToPpt} />
    </div>
  );
};

export default Wsr;
